import { render, staticRenderFns } from "./BuyerData.vue?vue&type=template&id=586af2b6&"
import script from "./BuyerData.vue?vue&type=script&lang=js&"
export * from "./BuyerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports